// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-SRb","title":"Header_title__3NBxq","left":"Header_left__1BVta","clinicName":"Header_clinicName__lzUSp"};